module.exports = __webpack_public_path__ + "static/media/plug_118.f420240e.png";